import { collapseSection, expandSection } from "../../common/initAccordions.js";
import uniqueid from "lodash.uniqueid";

export default () => {
  document.querySelectorAll(".js-read-more").forEach((el, index) => {
    const container = el.closest(".container__col");
    const button = el.querySelector("button");
    const height = el.dataset.height;
    const id = uniqueid("readMore-");
    const buttonId = uniqueid("readMore-");

    if (!container) {
      return;
    }

    container.classList.add("read-more__container");
    container.setAttribute("tabindex", "-1");
    container.setAttribute("id", id);
    container.setAttribute("aria-labelledby", buttonId);
    container.style.transition = "height 500ms ease";

    collapseSection(container);

    if (height) {
      container.style.minHeight = `min(100vh, ${height}px)`;
    }

    button.setAttribute("aria-controls", id);
    button.setAttribute("id", buttonId);

    button.addEventListener("click", (e) => {
      button.setAttribute("aria-expanded", "true");
      expandSection(container);
      container.focus();
      container.classList.add("read-more__container--open");
    });
  });
};
